/* eslint-disable import/prefer-default-export */
const YANDEX_METRIKA_ID = 11881159;

const MAX_PREPAYMENTS = 2;

export { YANDEX_METRIKA_ID, MAX_PREPAYMENTS };
